<h2 mat-dialog-title>
    User
</h2>

<mat-dialog-content>

  <p>{{ user.full_name }}</p>
  <p>{{ user.email }}</p>

</mat-dialog-content>

<mat-dialog-actions align="end">

  <button mat-button (click)="closeDialog()" cdkFocusInitial>Close</button>
</mat-dialog-actions>